import { useState } from "react";
import { RotateCcw, UserX } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function RelistButton({ l, onRelist }) {
  const [open, setOpen] = useState(false);
  const click = () => (l.sold_to_name ? setOpen(true) : onRelist(false));
  return (
    <>
      <button data-testid={`dash-relist-${l.id}`} onClick={click} className="flex flex-1 items-center justify-center gap-1 rounded-lg py-2 text-xs font-semibold hover:bg-slate-100"><RotateCcw className="h-3.5 w-3.5" />Buyer didn't pay? Relist</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="relist-dialog" className="border-white/10 bg-[#173742] text-white">
          <DialogHeader>
            <DialogTitle className="font-display">Relist "{l.title}"?</DialogTitle>
            <DialogDescription className="text-slate-400">You marked this as sold to <span className="font-semibold text-white">{l.sold_to_name}</span>. If they didn't pay or collect, you can flag them as a no-show so our team can review.</DialogDescription>
          </DialogHeader>
          <div className="space-y-2">
            <button data-testid="relist-flag-noshow-btn" onClick={() => { setOpen(false); onRelist(true); }} className="flex w-full items-center justify-center gap-2 rounded-xl bg-red-500 py-3 text-sm font-bold hover:bg-red-600"><UserX className="h-4 w-4" />Relist &amp; flag {l.sold_to_name} as a no-show</button>
            <button data-testid="relist-only-btn" onClick={() => { setOpen(false); onRelist(false); }} className="w-full rounded-xl border border-white/15 py-3 text-sm font-semibold hover:bg-white/5">Just relist</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
